<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12">
        <v-alert v-for="(item, index) in mxUpdateUserErrors" :key="index" dense type="error" outlined text
                 dismissible transition="slide-x-transition" class="py-0 text-uppercase">
          {{ item[0] }}
        </v-alert>
        <v-text-field v-model="username" outlined dense hide-details="auto" label="Username" />
      </v-col>
      <v-col cols="12">
        <v-autocomplete v-model="homepage" dense outlined hide-details="auto" item-value="routeName"
                        item-text="alias" :items="getHomepageList()" label="Homepage" />
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="name" outlined dense hide-details="auto" label="Name" />
      </v-col>
      <v-col cols="12">
        <v-text-field v-model="email" outlined dense hide-details="auto" label="Email" />
      </v-col>
      <v-col cols="12">
        <v-switch v-model="active" label="Active" />
      </v-col>
      <v-col cols="12">
        <v-btn dark color="primary" :loading="mxUpdatingUser" @click="initUpdate">
          Save
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import { routeNames } from '../../../../../../router'
import { updateUser } from './../../../../mixins/users.mixin'
export default {
  name: 'VEditUser',
  mixins: [
    updateUser,
  ],
  props: {
    propUserId: Number,
    propUserData: Object,
  },
  data() {
    return {
      username: null,
      name: null,
      email: null,
      homepage: null,
      active: 0,
    }
  },
  watch: {
    propUserId() {
      this.username = this.propUserData.username
      this.name = this.propUserData.name
      this.email = this.propUserData.email
      this.active = this.propUserData.active
      this.homepage = this.propUserData.homepage
    },
  },
  methods: {
    getHomepageList() {
      return routeNames
    },
    initUpdate() {
      this.mxUpdateUser(this.propUserId, {
        username: this.username,
        name: this.name,
        email: this.email,
        homepage: this.homepage,
        active: this.active,
      }, () => {
        this.$emit('saved')
        this.$emit('close-dialog')
      })
    },
  },
}
</script>
